var map = {
	"./ab.svg": 43636,
	"./ad.svg": 52522,
	"./ae.svg": 21339,
	"./af.svg": 89448,
	"./ag.svg": 1817,
	"./ai.svg": 21423,
	"./al.svg": 13714,
	"./am.svg": 17027,
	"./ao.svg": 2401,
	"./aq.svg": 39703,
	"./ar.svg": 85252,
	"./as.svg": 82501,
	"./at.svg": 75322,
	"./au.svg": 69195,
	"./aw.svg": 20137,
	"./ax.svg": 90350,
	"./az.svg": 42316,
	"./ba.svg": 27738,
	"./bb.svg": 72553,
	"./bd.svg": 8471,
	"./be.svg": 3142,
	"./bf.svg": 34917,
	"./bg.svg": 37668,
	"./bh.svg": 947,
	"./bi.svg": 13570,
	"./bj.svg": 70673,
	"./bl.svg": 73759,
	"./bm.svg": 59118,
	"./bn.svg": 42093,
	"./bo.svg": 94732,
	"./bq.svg": 4938,
	"./br.svg": 54233,
	"./bs.svg": 41864,
	"./bt.svg": 60615,
	"./bv.svg": 34037,
	"./bw.svg": 96052,
	"./by.svg": 66130,
	"./bz.svg": 54817,
	"./ca.svg": 26521,
	"./cc.svg": 99963,
	"./cd.svg": 66900,
	"./cf.svg": 51286,
	"./cg.svg": 38407,
	"./ch.svg": 61840,
	"./ci.svg": 74081,
	"./ck.svg": 6979,
	"./cl.svg": 48700,
	"./cm.svg": 2973,
	"./cn.svg": 65150,
	"./co.svg": 27727,
	"./cr.svg": 2586,
	"./cu.svg": 97861,
	"./cv.svg": 98726,
	"./cw.svg": 86263,
	"./cx.svg": 10784,
	"./cy.svg": 73585,
	"./cz.svg": 19042,
	"./de.svg": 8936,
	"./dj.svg": 18063,
	"./dk.svg": 55486,
	"./dm.svg": 52176,
	"./do.svg": 59378,
	"./dz.svg": 59679,
	"./ec.svg": 44073,
	"./ee.svg": 29015,
	"./eg.svg": 40613,
	"./eh.svg": 61794,
	"./england.svg": 19216,
	"./er.svg": 61352,
	"./es.svg": 69273,
	"./et.svg": 94038,
	"./europeanunion.svg": 40167,
	"./fi.svg": 64886,
	"./fj.svg": 77845,
	"./fk.svg": 16564,
	"./fm.svg": 6218,
	"./fo.svg": 66824,
	"./fr.svg": 73997,
	"./ga.svg": 26413,
	"./gb.svg": 32046,
	"./gd.svg": 56960,
	"./ge.svg": 97521,
	"./gf.svg": 17122,
	"./gg.svg": 47699,
	"./gh.svg": 57572,
	"./gi.svg": 35589,
	"./gl.svg": 67096,
	"./gm.svg": 42601,
	"./gn.svg": 666,
	"./gp.svg": 98364,
	"./gq.svg": 26909,
	"./gr.svg": 14814,
	"./gs.svg": 77391,
	"./gt.svg": 76272,
	"./gu.svg": 74721,
	"./gw.svg": 42371,
	"./gy.svg": 30261,
	"./hk.svg": 23378,
	"./hm.svg": 28764,
	"./hn.svg": 31087,
	"./hr.svg": 78859,
	"./ht.svg": 92165,
	"./hu.svg": 94916,
	"./id.svg": 23234,
	"./ie.svg": 10611,
	"./il.svg": 37402,
	"./im.svg": 31275,
	"./in.svg": 73208,
	"./io.svg": 82217,
	"./iq.svg": 83503,
	"./ir.svg": 81180,
	"./is.svg": 9725,
	"./it.svg": 75794,
	"./je.svg": 58462,
	"./jm.svg": 60950,
	"./jo.svg": 76564,
	"./jp.svg": 91347,
	"./ke.svg": 39437,
	"./kg.svg": 31423,
	"./kh.svg": 28536,
	"./ki.svg": 63401,
	"./km.svg": 59941,
	"./kn.svg": 60806,
	"./kp.svg": 23920,
	"./kr.svg": 31122,
	"./kw.svg": 89807,
	"./ky.svg": 88601,
	"./kz.svg": 44202,
	"./la.svg": 50060,
	"./lb.svg": 21759,
	"./lc.svg": 654,
	"./li.svg": 95556,
	"./lk.svg": 51142,
	"./lr.svg": 80143,
	"./ls.svg": 17566,
	"./lt.svg": 26497,
	"./lu.svg": 14256,
	"./lv.svg": 59395,
	"./ly.svg": 19316,
	"./ma.svg": 99619,
	"./mc.svg": 31969,
	"./md.svg": 72062,
	"./me.svg": 34639,
	"./mf.svg": 55612,
	"./mg.svg": 84157,
	"./mh.svg": 15882,
	"./mk.svg": 41881,
	"./ml.svg": 74550,
	"./mm.svg": 14087,
	"./mn.svg": 26228,
	"./mo.svg": 87509,
	"./mp.svg": 74370,
	"./mq.svg": 4947,
	"./mr.svg": 97856,
	"./ms.svg": 54769,
	"./mt.svg": 89294,
	"./mu.svg": 27231,
	"./mv.svg": 48204,
	"./mw.svg": 83661,
	"./mx.svg": 57914,
	"./my.svg": 63179,
	"./mz.svg": 24344,
	"./na.svg": 73910,
	"./nc.svg": 89524,
	"./ne.svg": 38922,
	"./nf.svg": 30297,
	"./ng.svg": 64904,
	"./ni.svg": 87774,
	"./nl.svg": 22659,
	"./no.svg": 65616,
	"./northerncyprus.svg": 48413,
	"./np.svg": 59415,
	"./nr.svg": 67461,
	"./nu.svg": 6362,
	"./nz.svg": 93037,
	"./om.svg": 95601,
	"./pa.svg": 2976,
	"./pe.svg": 73484,
	"./pf.svg": 45183,
	"./pg.svg": 24078,
	"./ph.svg": 77161,
	"./pk.svg": 78426,
	"./pl.svg": 73701,
	"./pm.svg": 18980,
	"./pn.svg": 62103,
	"./pr.svg": 99171,
	"./ps.svg": 44882,
	"./pt.svg": 78813,
	"./pw.svg": 40990,
	"./py.svg": 94440,
	"./qa.svg": 42839,
	"./re.svg": 13686,
	"./ro.svg": 75900,
	"./rs.svg": 93656,
	"./ru.svg": 68454,
	"./rw.svg": 39716,
	"./sa.svg": 50313,
	"./sb.svg": 82202,
	"./sc.svg": 96811,
	"./scotland.svg": 12721,
	"./sd.svg": 92132,
	"./se.svg": 43301,
	"./sg.svg": 35255,
	"./sh.svg": 83072,
	"./si.svg": 19025,
	"./sj.svg": 98658,
	"./sk.svg": 3827,
	"./sl.svg": 69932,
	"./sm.svg": 68877,
	"./sn.svg": 20526,
	"./so.svg": 48959,
	"./southossetia.svg": 65620,
	"./sr.svg": 31114,
	"./ss.svg": 91483,
	"./st.svg": 65364,
	"./sv.svg": 66102,
	"./sx.svg": 41456,
	"./sy.svg": 76993,
	"./sz.svg": 83858,
	"./tc.svg": 11206,
	"./td.svg": 40649,
	"./tf.svg": 87147,
	"./tg.svg": 72538,
	"./th.svg": 59213,
	"./tj.svg": 39295,
	"./tk.svg": 10862,
	"./tl.svg": 9361,
	"./tm.svg": 73408,
	"./tn.svg": 94163,
	"./to.svg": 88994,
	"./tr.svg": 20263,
	"./tt.svg": 96473,
	"./tv.svg": 81819,
	"./tw.svg": 21450,
	"./tz.svg": 97679,
	"./ua.svg": 44763,
	"./ug.svg": 5045,
	"./um.svg": 44847,
	"./unitednations.svg": 52224,
	"./us.svg": 43561,
	"./uy.svg": 71955,
	"./uz.svg": 27296,
	"./va.svg": 82542,
	"./vc.svg": 18156,
	"./ve.svg": 36994,
	"./vg.svg": 79712,
	"./vi.svg": 26566,
	"./vn.svg": 95977,
	"./vu.svg": 89554,
	"./wales.svg": 92959,
	"./wf.svg": 92466,
	"./ws.svg": 92767,
	"./xk.svg": 7458,
	"./ye.svg": 55747,
	"./yt.svg": 55906,
	"./za.svg": 8322,
	"./zm.svg": 30534,
	"./zw.svg": 37980,
	"./zz.svg": 15801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37938;